var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`module_box ${_vm.moduleBg?'module_bg':''} ${_vm.moduleBgBlue?'module_bg_blue':''}`},[_c('div',{staticClass:"width"},[_c('div',{staticClass:"module_title"},[_vm._v(_vm._s(_vm.moduleInfo.title))]),_c('div',{staticClass:"module_title_desc"},[_c('div',[_vm._v(_vm._s(_vm.moduleInfo.desc.text1))])]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }